import React from "react";
import { Link } from "react-router";

function Tools({ count, deleteStudygroups }) {
  return (
    <div className="admin_list">
      <h5>
        MedMeetings (<span>{count}</span>)
      </h5>
      <Link className="button_classic" to="/groups/new">
        Add MedMeeting
      </Link>
      <a className="button_delete" onClick={deleteStudygroups}>
        Delete
      </a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Toolbar/Tools.jsx